import { Input } from './Input';

function SearchIcon({ className = 'w-[18px] h-[18px]' }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" strokeWidth="1.5" />
      <path strokeWidth="1.5" strokeLinecap="round" d="M20 20l-3.5-3.5" />
    </svg>
  );
}

/**
 * Search field with leading magnifier icon.
 * Flat light-grey pill style (no border) — matches Figma search bars.
 */
export function SearchInput({
  className = '',
  inputClassName = '',
  size = 'md',
  value,
  onChange,
  isLoading = false,
  ...props
}) {
  return (
    <div className={`relative w-full rounded-[12px] ${className}`}>
      <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#868686] pointer-events-none z-10">
        {isLoading ? (
          <div className="w-4 h-4 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        ) : (
          <SearchIcon />
        )}
      </span>
      <Input
        size={size}
        type="text"
        value={value}
        onChange={onChange}
        className={`pl-10 sm:pl-11 !h-[44px] !rounded-[12px] !bg-[#F5F5F5] !border-0 text-[#1F2241] placeholder:!text-[#868686] focus:!border-0 focus:!ring-0 focus:!outline-none cursor-text ${inputClassName}`}
        {...props}
      />
    </div>
  );
}
